class Daypart {
  static init({ sections = document.querySelectorAll('[class*="Daypart"]') }) {
    const today = new Date();
    const day = today.getDate();
    const hour = today.getHours();
    const minute = today.getMinutes();
    Object.assign(this, {
      today,
      day,
      hour,
      minute,
      sections,
    });
  }

  static isMorning() {
    if (this.hour > 6 && this.hour < 10) {
      return true;
    }
    else if (this.hour == 6 && this.minute >= 30) {
      return true;
    }
    else if (this.hour == 10 && this.minute <= 30) {
      return true;
    }
    return false;
  }

  static isAfternoon() {
    return !this.isMorning() && !this.isLateNight();
  }

  static isLateNight() {
    if (this.hour >= 22) {
      return true;
    } else if (this.hour < 7 && !this.isMorning()) {
      return true;
    }
    return false;
  }

  static apply() {
    let currentModifier;
    if (this.isMorning()) {
      currentModifier = 'Daypart--morning';
    } else if (this.isLateNight()) {
      currentModifier = 'Daypart--latenight';
    } else {
      currentModifier = 'Daypart--afternoon';
    }

    const { sections } = this;
    let foundPromoSection = false;
    let foundProductSection = false;

    // Have to check if sections exists
    for (let section of sections) {
      if (section.classList.contains(currentModifier)) {
        if (section.classList.contains('Promo')) {
          foundPromoSection = true;
        } else if (section.classList.contains('ProductList')) {
          foundProductSection = true;
        }
      }
    }

    // Hide/Show correct sections
    let showing = false;
    for (let section of sections) {
      let modifier = 'Daypart--afternoon';
      if (section.classList.contains('Promo')) {
        modifier = foundPromoSection ? currentModifier : modifier;
      } else if (section.classList.contains('ProductList')) {
        modifier = foundProductSection ? currentModifier : modifier;
      }

      if (section.classList.contains(modifier)) {
        section.classList.add('Daypart--show');
        showing = true;
      } else if (!this.isMorning() && section.classList.contains('Daypart--morning') && !showing) {
        section.classList.add('Daypart--show');
      } else {
        section.classList.add('Daypart--hide');
      }

      section.classList.remove('Daypart--morning');
      section.classList.remove('Daypart--afternoon');
      section.classList.remove('Daypart--latenight');
    }
  }

  static loadAndRun({ sections } = {}) {
    this.init({ sections });
    this.apply();
  }
}

export { Daypart }
